import { ReactNode } from "react";

interface EmptyStateProps {
  icon: ReactNode;
  title?: string;
  subtitle?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, subtitle, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-10">
      <div className="mb-3">{icon}</div>
      <div className="flex flex-col items-center justify-center gap-1.5">
        {title && (
          <p className="text-sm font-semibold text-[#1D2939]">{title}</p>
        )}
        {subtitle && (
          <p className="text-[12px] font-medium text-[#8A94A6]">{subtitle}</p>
        )}
      </div>
      {action && <div className="mt-[18px]">{action}</div>}
    </div>
  );
}
